<div class="swiper-container swiper" #swiperComponent>
  <ng-content></ng-content>
</div>
